__turbopack_context__.v({
  "pill": "widget-integration-select-module__4T6agq__pill",
});
